<template>
  <div id="mapContainer" class="mapContainer">
    <div id="vehicleIdentifyMap" class="map"></div>
  </div>
</template>

<script>
import * as purchaseAllowanceApi from "@/api/governmentAffairs/purchaseAllowance.js";
import { getMapSeting } from "@/api/ai.js";
import Vue from "vue";
import { fromLonLat } from "ol/proj";
import Map from "ol/Map";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay";
import Point from "ol/geom/Point";
import { LineString } from "ol/geom";
import Cluster from "ol/source/Cluster";
import { Tile as TileLayer, Image } from "ol/layer";
import { DoubleClickZoom, DragPan, MouseWheelZoom } from "ol/interaction";
import VectorSource from "ol/source/Vector";
import { Vector as VectorLayer } from "ol/layer";
import { XYZ } from "ol/source";
import View from "ol/View";
import GeoJSON from "ol/format/GeoJSON.js";
import chinaJson from "@/assets/JSON/china.json";
import { TileSuperMapRest, Mapv } from "@supermap/iclient-ol";
import { defaults as defaultControls } from "ol/control";
import { Style, Icon, Stroke, Circle, Fill, Text } from "ol/style";
import * as mapv from "mapv";

export default {
  props: {
    areaInfoList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      // 地图对象
      map: null,
      // 特效图
      imgLayer: null,
      // 是否是省级单位
      isProvinceLevel: true,
      // 省边界
      boundaryLayer: null,
      // 图标层
      iconLayer: null,
      marker: null,
      cloneFeature: [],
      selectFeature: null,
      winCotent: null,
      winTooltip: null,
      // 边界样式
      styles: {
        boundary: new Style({
          fill: new Fill({
            color: "rgba(0,0,0,0)",
          }),
          stroke: new Stroke({
            color: "RGBA(189, 255, 222, 1)",
            width: 2,
          }),
        }),
      },
      layers: {
        baseLayer: null,
      },
      // 河南经纬度
      startLongAndLat: [],
      copyAreaInfoList: [],
      mapSeting: null,
    };
  },
  async mounted() {
    // 获取地图配置
    let params = {
      areaCode: "410000000",
      largeScreenType: "vehicleIdentify",
    };
    this.mapSeting = await getMapSeting(params);
    this.initMap();
  },
  watch: {
    // areaInfoList() {
    //   this.addCiyMarker();
    // },
  },
  computed: {},
  methods: {
    deepCloneFeature(feature) {
      // 创建新的特征，使用原始特征的几何
      const clonedFeature = new Feature({
        geometry: feature.getGeometry().clone(),
      });

      // 克隆特征的样式
      const originalStyle = feature.getStyle();
      const clonedStyle = originalStyle.clone();

      clonedFeature.setStyle(clonedStyle);
      // 克隆特征的属性
      const properties = feature.getProperties();
      const clonedProperties = {};
      for (const key in properties) {
        if (properties.hasOwnProperty(key)) {
          clonedProperties[key] = properties[key];
        }
      }
      clonedFeature.setProperties(clonedProperties);

      return clonedFeature;
    },
    // 添加地图区域图标、区域上色、数值
    addCiyMarker() {
      const features = this.boundaryLayer.getSource().getFeatures();
      let that = this;
      this.copyAreaInfoList = [];
      for (let i = 0; i < this.areaInfoList.length; i++) {
        for (let j = 0; j < features.length; j++) {
          if (this.areaInfoList[i].name == features[j].get("fullName")) {
            this.copyAreaInfoList.push({
              name: features[j].get("name"),
              value: this.areaInfoList[i].value,
            });
            features[j].set("needName", features[j].get("name"));
            features[j].set("needNum", this.areaInfoList[i].value);
            break;
          }
        }
      }

      features.forEach((f) => {
        // const iconFeature = new Feature({
        //   geometry: new Point(f.get('cp')),
        //   name: f.get('name')
        // })
        // iconFeature.set('adcode', f.get('adcode'))
        // iconFeature.set('keyId', `city_${f.get('adcode')}`)
        if (f.get("needName")) {
          const iconFeature = new Feature({
            geometry: new Point(f.get("cp")),
            name: f.get("name"),
          });
          iconFeature.setStyle(
            new Style({
              image: new Icon({
                src: require(`@/assets/images/governmentAffairs/vehicleIdentify/map/${f.get(
                  "needName"
                )}.png`),
                scale: 1,
                anchor: [0.5, 1],
                // displacement: [10, -20]
                displacement: f.get("needName") != "河南" ? [0, 0] : [4, -30],
              }),
            })
          );
          let fill = f.getStyle().getFill();
          let stroke = f.getStyle().getStroke();
          if (f.get("needName") == "河南") {
            that.startLongAndLat = f.get("cp");
            fill.setColor("RGBA(231, 153, 0, 1)");
            stroke.setColor("RGBA(189, 255, 222, 1)");
          } else {
            let overlay = that.creatOverlay(f);
            that.map.addOverlay(overlay);
            fill.setColor("RGBA(0, 128, 57, 1)");
            stroke.setColor("RGBA(189, 255, 222, 1)");
          }
          f.setStyle(f.getStyle());
          this.iconLayer.getSource().addFeature(iconFeature);
        }
      });

      // 创省到省建线
      this.createLine();
    },
    createLine() {
      const rData = [];
      const to = "河南";
      this.copyAreaInfoList.forEach((d) => {
        rData.push({
          from: d.name,
          count: d.value,
          to: to,
        });
      });
      const qianxi = new mapv.DataSet(rData);
      const qianxiData = qianxi.get();
      const lineData = [];
      const pointData = [];
      const timeData = [];
      const citys = {};
      for (var i = 0; i < qianxiData.length; i++) {
        var fromCenter = mapv.utilCityCenter.getCenterByCityName(
          qianxiData[i].from
        );
        var toCenter = mapv.utilCityCenter.getCenterByCityName(
          qianxiData[i].to
        );
        if (!fromCenter || !toCenter) {
          continue;
        }
        citys[qianxiData[i].from] = qianxiData[i].count;
        citys[qianxiData[i].to] = 100;
        pointData.push({
          geometry: {
            type: "Point",
            coordinates: [fromCenter.lng, fromCenter.lat],
          },
        });
        pointData.push({
          geometry: {
            type: "Point",
            coordinates: [toCenter.lng, toCenter.lat],
          },
        });

        var curve = mapv.utilCurve.getPoints([fromCenter, toCenter]);

        for (var j = 0; j < curve.length; j++) {
          timeData.push({
            geometry: {
              type: "Point",
              coordinates: curve[j],
            },
            count: 1,
            time: j,
          });
        }
        lineData.push({
          geometry: {
            type: "LineString",
            coordinates: curve,
          },
          count: 30 * Math.random(),
        });
      }
      const lineDataSet = new mapv.DataSet(lineData);
      const lineOptions = {
        strokeStyle: "rgba(255, 255, 0, 0.5)",
        shadowColor: "rgba(123,43,0,0.5)",
        shadowBlur: 20,
        lineWidth: 2,
        zIndex: 100,
        draw: "simple",
      };
      this.map.addLayer(
        new Image({
          source: new Mapv({
            map: this.map,
            dataSet: lineDataSet,
            mapvOptions: lineOptions,
          }),
          zIndex: 5,
        })
      );

      var pointOptions = {
        fillStyle: "RGBA(255, 255, 255, 0)",
        shadowColor: "RGBA(255, 255, 255, 0)",
        shadowBlur: 0,
        size: 0,
        zIndex: 10,
        draw: "simple",
      };

      var pointDataSet = new mapv.DataSet(pointData);

      this.map.addLayer(
        new Image({
          source: new Mapv({
            map: this.map,
            dataSet: pointDataSet,
            mapvOptions: pointOptions,
          }),
          zIndex: 5,
        })
      );

      var timeDataSet = new mapv.DataSet(timeData);
      // 运动点配置
      var timeOptions = {
        fillStyle: "rgba(255, 255, 179, 1)",
        shadowColor: "rgba(255, 255, 179, 1)",
        lineWidth: 1, // 边框宽度
        draw: "rect", // 指定绘制矩形
        size: 1, // 矩形宽高（需确认是否支持数组格式）
        shadowBlur: 3,
        animation: {
          type: "time",
          stepsRange: {
            start: 10,
            end: 50,
          },
          trails: 3,
          duration: 2,
        },
      };
      this.map.addLayer(
        new Image({
          source: new Mapv({
            map: this.map,
            dataSet: timeDataSet,
            mapvOptions: timeOptions,
          }),
          zIndex: 5,
        })
      );
    },
    // 创建数值样式
    creatOverlay(feature, className) {
      let element = document.createElement("div");
      element.className = "vehicle-identify-map-box";
      element.innerHTML = `
        <div class="map-value">${feature.get("needNum")}</div>
      `;
      let overlay = new Overlay({
        element: element,
        position: feature.get("cp"),
        offset: [0, -34],
        positioning: "top-center",
        stopEvent: false,
      });
      return overlay;
    },
    resetStyle(feature) {
      if (feature) {
        this.cloneFeature.forEach((f) => {
          if (f.get("keyId") === feature.get("keyId")) {
            feature.setStyle(f.getStyle().clone());
          }
        });
        const iconFeatures = this.iconLayer.getSource().getFeatures();
        for (let i = 0; i < iconFeatures.length; i++) {
          if (iconFeatures[i].get("adcode") == feature.get("adcode")) {
            iconFeatures[i].setStyle(
              new Style({
                image: new Icon({
                  src: require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${feature.get(
                    "name"
                  )}.png`),
                  scale: 1,
                  anchor: [0.5, 1],
                  // displacement: [10, -20]
                  displacement: [0, 0],
                }),
              })
            );
          }
        }
      }
    },
    checkedIconFeatures(feature) {
      let iconFeatures = this.iconLayer.getSource().getFeatures();
      for (let i = 0; i < iconFeatures.length; i++) {
        if (iconFeatures[i].get("adcode") == feature.get("adcode")) {
          iconFeatures[i].setStyle(
            new Style({
              image: new Icon({
                src: require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${feature.get(
                  "name"
                )}-c.png`),
                scale: 1,
                anchor: [0.5, 1],
                // displacement: [10, -30]
                displacement: [0, -16],
              }),
            })
          );
        } else {
          iconFeatures[i].setStyle(
            new Style({
              image: new Icon({
                src: require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${iconFeatures[
                  i
                ].get("name")}.png`),
                scale: 1,
                anchor: [0.5, 1],
                // displacement: [10, -20]
                displacement: [0, 0],
              }),
            })
          );
        }
      }
    },
    mapClick(feature, coordinates) {
      if (feature && feature.get("adcode")) {
        const features = this.boundaryLayer.getSource().getFeatures();
        features.forEach((f) => {
          if (feature.get("adcode") === f.get("adcode")) {
            const fill = f.getStyle().getFill();
            const stroke = f.getStyle().getStroke();
            fill.setColor("RGBA(0, 176, 12, 1)");
            stroke.setColor("RGBA(255, 255, 255, 1)");
            f.setStyle(f.getStyle());
            this.checkedIconFeatures(feature);
            this.selectFeature = f;
          } else {
            this.resetStyle(f);
          }
        });
      } else {
        this.resetStyle(this.selectFeature);
      }
    },
    // 鼠标悬浮各区域
    pointMove(feature, coordinates) {},
    initMap() {
      let that = this;
      this.iconLayer = new VectorLayer({
        // declutter: false, // 发生碰撞时清理掉与其重叠的 feature（不能实现避让）
        zIndex: 3,
        source: new VectorSource(),
      });
      this.map = new Map({
        target: "vehicleIdentifyMap",
        layers: [this.iconLayer],
        controls: defaultControls({
          attribution: false,
        }),
        view: new View({
          center: that.mapSeting.center.split(",") || [86.4, 36.9],
          zoom: that.mapSeting.zoom || 4.7,
          // center: [86.40, 36.90],
          // zoom: 4.7,
          projection: "EPSG:4326",
          maxZoom: 14,
          minZoom: 3.5,
        }),
      });
      // 禁用拖动
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof DragPan) {
          interaction.setActive(false);
        }
      });
      // 禁用双击缩放
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof DoubleClickZoom) {
          interaction.setActive(false);
        }
      });
      // 禁用滚轮缩放
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof MouseWheelZoom) {
          interaction.setActive(false);
        }
      });
      that.map.on("click", function (evt) {
        var pixel = that.map.getEventPixel(evt.originalEvent);
        const feature = that.map.forEachFeatureAtPixel(
          pixel,
          function (feature) {
            return feature;
          }
        );
        that.mapClick(feature, evt.coordinate);
      });
      if (this.mapSeting && this.mapSeting.specialEffectsUrl) {
        let imgLayer = new TileLayer({
          source: new TileSuperMapRest({
            url: that.mapSeting.specialEffectsUrl,
            cacheEnabled: true,
          }),
          zIndex: 1,
          isGroup: true,
          name: "高清影像图",
        });
        this.map.addLayer(imgLayer);
      } else {
        console.log("农机鉴定，特效图不存在");
      }
      let needUrl = that.$utils.getGeoJsonUrl(that.mapSeting.geoJsonUrl);
      // 获取geojson
      this.$ajax
        .get(needUrl) // 假设文件位于静态资源目录
        .then((response) => {
          const geojsonFormat = new GeoJSON();
          let features = geojsonFormat.readFeatures(response.data);
          this.boundaryLayer = new VectorLayer({
            source: new VectorSource({
              features: features,
            }),
            zIndex: 2,
          });
          this.boundaryLayer
            .getSource()
            .getFeatures()
            .forEach((f) => {
              f.set("type", "boundary");
              f.set("keyId", `boundary_${f.get("adcode")}`);
              f.setStyle(this.styles.boundary.clone());
              const cloneF = new Feature(f.getProperties());
              cloneF.setStyle(f.getStyle().clone());
              this.cloneFeature.push(cloneF);
            });
          this.map.addLayer(this.boundaryLayer);
          this.addCiyMarker();
        });

      // that.map.on('pointermove', function (evt) {
      //   var pixel = that.map.getEventPixel(evt.originalEvent)
      //   const feature = that.map.forEachFeatureAtPixel(
      //     pixel,
      //     function (feature) {
      //       return feature
      //     },
      //     {
      //       layerFilter: function (layer) {
      //         return layer == that.boundaryLayer
      //       }
      //     }
      //   )
      //   that.pointMove(feature, evt.coordinate)
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.mapContainer {
  float: right;
  width: 100%;
  height: 100%;
  position: relative;
  ::v-deep {
    .ol-attribution.ol-unselectable.ol-control.ol-collapsed {
      display: none;
    }
    .ol-control {
      display: none;
    }
  }
}
.ol-zoom.ol-unselectable.ol-control {
  display: none;
}
.map {
  width: 100%;
  height: 100%;
}
.ol-rotate {
  display: none;
}
</style>
